/* The offer band is one button: tapping it copies the code and folds the band
   away. Tapping again opens it back up.

   Delegated from the document so the band survives being re-rendered — by a
   facet change, by the cart drawer refreshing, by the theme editor. */
(function () {
  var RESET_MS = 2000;

  function setLabel(scope, btn, text) {
    var label = btn.querySelector('[data-offer-copy-label]');
    if (!label) return;
    if (!btn.dataset.offerIdle) btn.dataset.offerIdle = label.textContent.trim();
    label.textContent = text;
    scope.classList.add('is-copied');
    window.clearTimeout(btn._offerTimer);
    btn._offerTimer = window.setTimeout(function () {
      label.textContent = btn.dataset.offerIdle;
      scope.classList.remove('is-copied');
    }, RESET_MS);
  }

  function legacyCopy(text) {
    // navigator.clipboard needs a secure context and is not everywhere yet.
    var ta = document.createElement('textarea');
    ta.value = text;
    ta.setAttribute('readonly', '');
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    var ok = false;
    try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
    document.body.removeChild(ta);
    return ok;
  }

  function copy(text) {
    if (navigator.clipboard && window.isSecureContext) {
      return navigator.clipboard.writeText(text).then(
        function () { return true; },
        function () { return legacyCopy(text); }
      );
    }
    return Promise.resolve(legacyCopy(text));
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-offer-copy], [data-offer-toggle]');
    if (!btn) return;
    e.preventDefault();

    var band = btn.closest('.offer-band') || btn;
    var code = btn.getAttribute('data-offer-copy');

    if (code) {
      copy(code).then(function (ok) {
        // Say "Copied" only when it was. Otherwise leave the code on screen
        // to be read rather than claim something that did not happen.
        setLabel(band, btn, ok ? 'Copied' : 'Copy it above');
      });
    }

    if (btn.hasAttribute('data-offer-toggle')) {
      var collapsed = band.classList.toggle('is-collapsed');
      btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    }
  });
})();
